import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {Button} from 'primeng/button';

@Component({
  selector: 'app-primary-button',
  standalone: true,
  templateUrl: './primary-button.html',
  imports: [
    TranslatePipe,
    Button,
  ],
  styleUrl: './primary-button.scss'
})
export class PrimaryButton {
 @Output() action = new EventEmitter<MouseEvent>();
 @Input() title: string = '';
 @Input() width: string = 'auto';
 @Input() icon!: string ;
 @Input() loading: boolean = false;
 @Input() disable: boolean = false;
 @Input() size: 'small' | 'large'| 'p-button-sm' | 'p-button-md' | undefined | any = undefined
}
